export const HC_HOME_VISIBLE_TRANSACTION_COUNT = 3
export const HC_ROOT_FAQ_ID = 3
